export default __webpack_public_path__ + "static/media/whatsapp.4e0f0452.png";